module.exports = __webpack_public_path__ + "img/BabyComposerLogo.39ef01d6.png";